module.exports = __webpack_public_path__ + "img/telegram-color.4fdd307d.svg";